import Cookies from 'js-cookie'

const TokenKey = 'Green-Job-Mobile'
export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}
const SimpleTokenKey = "Green-Job-Mobile-Simple"
export function getSimpleToken() {
    return localStorage.getItem(SimpleTokenKey)
}
export function setSimpleToken(token) {
    return localStorage.setItem(SimpleTokenKey, token)
}

const SalaryPass = 'Green-Job-Salary-Pass'
export function getSalaryPass() {
  return Cookies.get(SalaryPass)

}

export function setSalaryPass(salaryPass) {
  return Cookies.set(SalaryPass, salaryPass, { expires: 1/24/2 })
}

export function removeSalaryPass() {
  return Cookies.remove(SalaryPass)
}



const WechatAutoLoginFlag = 'WechatAutoLogin-Flag'
export function getWechatAutoLoginFlag() {
  return Cookies.get(WechatAutoLoginFlag)
}

export function setWechatAutoLoginFlag(flag) {
  return Cookies.set(WechatAutoLoginFlag, flag)
}

export function removeWechatAutoLoginFlag() {
  return Cookies.remove(WechatAutoLoginFlag)
}


const WechatAutoLoginCode = 'WechatAutoLogin-Code'
export function getWechatAutoLoginCode() {
  return Cookies.get(WechatAutoLoginCode)
}

export function setWechatAutoLoginCode(code) {
  return Cookies.set(WechatAutoLoginCode, code)
}

export function removeWechatAutoLoginCode() {
  return Cookies.remove(WechatAutoLoginCode)
}



const passLoginFlag = 'passLoginFlag-Code'
export function getPassLoginFlagCode() {
  return Cookies.get(passLoginFlag)
}

export function setPassLoginFlagCode(code) {
  return Cookies.set(passLoginFlag, code)
}

export function removePassLoginFlagCode() {
  return Cookies.remove(passLoginFlag)
}

const partnerTokenKey = 'Green-Job-Partner'
export function getPartnerToken() {
  return Cookies.get(partnerTokenKey)
}

export function setPartnerToken(partnerToken) {
  return Cookies.set(partnerTokenKey, partnerToken)
}

export function removePartnerToken() {
  return Cookies.remove(partnerTokenKey)
}

const partnerWechatAutoLoginFlag = 'partnerWechatAutoLogin-Flag'
export function getPartnerWechatAutoLoginFlag() {
  return Cookies.get(partnerWechatAutoLoginFlag)
}

export function setPartnerWechatAutoLoginFlag(flag) {
  return Cookies.set(partnerWechatAutoLoginFlag, flag)
}

export function removePartnerWechatAutoLoginFlag() {
  return Cookies.remove(partnerWechatAutoLoginFlag)
}

const partnerWechatAutoLoginCode = 'partnerWechatAutoLogin-Code'
export function getPartnerWechatAutoLoginCode() {
  return Cookies.get(partnerWechatAutoLoginCode)
}

export function setPartnerWechatAutoLoginCode(code) {
  return Cookies.set(partnerWechatAutoLoginCode, code)
}

export function removePartnerWechatAutoLoginCode() {
  return Cookies.remove(partnerWechatAutoLoginCode)
}

const userTypeCode = 'userType-Code'
export function getUserTypeCode() {
  return Cookies.get(userTypeCode)
}

export function setUserTypeCode(code) {
  return Cookies.set(userTypeCode, code)
}

export function removeUserTypeCode() {
  return Cookies.remove(userTypeCode)
}

const appTokenKey = 'grejobAppOauthLogin'
export function getAppToken() {
  return localStorage.getItem(appTokenKey)
}

export function setAppToken(appToken) {
  return localStorage.setItem(appTokenKey, appToken,{ expires: 31 })
}

export function removeAppToken() {
  return localStorage.removeItem(appTokenKey)
}

const companyCodeHeaderKey = 'companyCodeHeader'

export function getCompanyCodeHeaderKey() {
  return Cookies.get(companyCodeHeaderKey)
}

export function removeCompanyCodeHeaderKey() {
  return Cookies.remove(companyCodeHeaderKey)
}

const individualHeaderKey = 'individualHeader'

export function getIndividualHeaderKey() {
  return Cookies.get(individualHeaderKey)=='true'?true:false;
}

export function removeIndividualHeaderKey() {
  return Cookies.remove(individualHeaderKey)
}

